<template>
    <div class="enterprise">

        <box-helper
            headline="Entreprise"
            identifier="enterprise"
        />

        <div class="container section">
            <title-block headline="<b>Entreprise</b>" class="mb-xl" position="center">
                <p slot="text">
                    Ét samlet overblik over din entreprise-forretning
                </p>
            </title-block>

            <content-switch
                :items="switchItems"
                :selectedItem="selectedItem"
                :counts="counts"
                @selectItem="handleSelectItem($event)"
            />

            <main-project-types v-show="selectedItem === 'mainProjectTypes'" @finishedLoading="updateCount('mainProjectTypes', $event)" />

            <main-projects v-show="selectedItem === 'mainProjects'" @finishedLoading="updateCount('mainProjects', $event)" />

            <employees-sub-projects v-show="selectedItem === 'employeesSubProjects'" @finishedLoading="updateCount('employeesSubProjects', $event)" />

            <sub-project-types v-show="selectedItem === 'subProjectTypes'" @finishedLoading="updateCount('subProjectTypes', $event)" />
            
        </div>
    </div>
</template>

<script>

export default {
    data () {
        return {
            showHelper: false,
            selectedItem: 'mainProjectTypes',
            counts: {
                mainProjectTypes: null,
                mainProjects: null,
                employeesSubProjects: null,
                subProjectTypes: null
            },
            switchItems: [
                {
                    name: 'Hvilke entreprisetyper tjenes der penge på?',
                    slug: 'mainProjectTypes'
                },
                {
                    name: 'Hvilke konkrete entrepriseopgaver tjenes der penge på?',
                    slug: 'mainProjects'
                },
                {
                    name: 'Hvordan er effektiviteten på underentrepriserne?',
                    slug: 'subProjectTypes'
                },
                {
                    name: 'Hvordan er medarbejdernes effektivitet?',
                    slug: 'employeesSubProjects'
                }
            ]
        }
    },
    methods: {
        updateCount (slug, event) {
            this.counts[slug] = event
        },
        handleSelectItem (item) {
            this.selectedItem = item
        }
    },
    components: {
        'main-project-types': require('./components/mainProjectTypes.vue'),
        'main-projects': require('./components/mainProjects.vue'),
        'employees-sub-projects': require('./components/employeesSubProjects.vue'),
        'sub-project-types': require('./components/subProjectTypes.vue')
    }
}
</script>



// WEBPACK FOOTER //
// index.vue?e5f3c9da